import React, { useContext } from 'react';
import classNames from 'classnames';
import { JobSearchContext } from '../../context';
import './_featured_organization.scss';

const FeaturedOrg = () => {
  const { landingPageInfo } = useContext(JobSearchContext);

  const {
    featured_organization_color,
    featured_organization_logo_url,
    featured_organization_link_url,
    featured_organization_headline,
    featured_organization_links,
  } = landingPageInfo;

  const cloudinaryLogoUrl =
    'https://res.cloudinary.com/devex/image/fetch/c_fit,h_100,w_135/' +
    featured_organization_logo_url;

  const displayedLinks = featured_organization_links.slice(0, 4);

  const renderLinks: JSX.Element = (
    <div className='links'>
      <div className='separator' style={{ backgroundColor: featured_organization_color }} />
      {displayedLinks.map((link) => (
        <a
          key={link.title}
          className='link'
          href={link.url}
          target='_blank'
          rel='noreferrer'
        >
          <span className='margin-right-small'>{link.title}</span>
          <i
            className='fal icon-angle-double-right'
            style={{ color: featured_organization_color }}
          />
        </a>
      ))}
    </div>
  );

  const renderLogoWithoutLink: JSX.Element = (
    <div className='logo'>
      <img src={cloudinaryLogoUrl} alt='Featured company logo' />
    </div>
  );

  const renderLogoWithLink: JSX.Element = (
    <div className='logo'>
      <a
        target='_blank'
        href={featured_organization_link_url}
        className='logo-link block'
        rel='noreferrer'
      >
        <img src={cloudinaryLogoUrl} alt='Featured company logo' />
      </a>
    </div>
  );

  const renderHeadline: JSX.Element = (
    <div className='headline'>
      <h2>
        {featured_organization_link_url ? (
          <a
            href={featured_organization_link_url}
            target='_blank'
            className='headline-link'
            rel='noreferrer'
          >
            <span dangerouslySetInnerHTML={{ __html: featured_organization_headline }}></span>
          </a>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: featured_organization_headline }}></span>
        )}
      </h2>
    </div>
  );

  return (
    <div className='my-4 mx-0 featured-org-new'>
      <div className='background' style={{ background: featured_organization_color }} />
      <div className={classNames('content', { 'with-logo': featured_organization_logo_url })}>
        <div
          className='background clipped'
          style={{ backgroundColor: featured_organization_color }}
        />
        {renderHeadline}
        {Boolean(featured_organization_links.length) && renderLinks}

        {Boolean(featured_organization_logo_url) &&
          (featured_organization_link_url ? renderLogoWithLink : renderLogoWithoutLink)}
      </div>
    </div>
  );
};

export default FeaturedOrg;
